// Sorry for whoever has to edit this in the future!
// JQuery mask plugins can be found in this folder, validation is in the jquery-validation-rails gem
// Good luck god bless

import "jquery-validation";

function isDateValid(dateStr) {
  return !isNaN(new Date(dateStr));
}

$(function () {
  $.validator.addMethod(
    "email-required",
    function (value, element) {
      return (
        this.optional(element) ||
        /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]+$/i.test(value)
      );
    },
    "Please enter a valid email address."
  );

  $.validator.addMethod(
    "email",
    function (value, element) {
      if (value !== "") {
        return (
          this.optional(element) ||
          /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]+$/i.test(value)
        );
      }
      return true;
    },
    "Please enter a valid email address."
  );

  $.validator.addMethod(
    "alpha-required",
    function (value, element) {
      return this.optional(element) || /^[A-Z.'\s-]+$/i.test(value);
    },
    "Please enter only letters, hyphens, periods, and apostrophes."
  );

  $.validator.addMethod(
    "number-required",
    function (value, element) {
      return this.optional(element) || /^[0-9.\s-]+$/i.test(value);
    },
    "Please enter a valid number."
  );

  $.validator.addMethod(
    "phone-required",
    function (value, element) {
      return (
        this.optional(element) ||
        /^\([0-9\-]{3,3}\) [0-9\-]{3,3}-[0-9\-]{4,4}$/.test(value)
      );
    },
    "Please enter a valid phone number."
  );

  $.validator.addMethod(
    "phone",
    function (value, element) {
      if (!/^\([\_]{3,3}\) [\_]{3,3}-[\_]{4,4}$/.test(value)) {
        return (
          this.optional(element) ||
          /^\([0-9\-]{3,3}\) [0-9\-]{3,3}-[0-9\-]{4,4}$/.test(value)
        );
      }
      return true;
    },
    "Please enter a valid phone number."
  );

  $.validator.addMethod(
    "currency-required",
    function (value, element) {
      return this.optional(element) || /^\$[0-9,]+\.[0-9]{2,2}$/.test(value);
    },
    "Please enter a valid US currency denomination."
  );

  $.validator.addMethod(
    "date-required",
    function (value, element) {
      return (
        this.optional(element) ||
        (/^[0-9\-]{2,2}\/[0-9\-]{2,2}\/[0-9\-]{4,4}$/.test(value) && isDateValid(value))
      );
    },
    "Please enter a valid date in MM/DD/YYYY format."
  );

  $.validator.addMethod(
    "date",
    function (value, element) {
      if (!/^[\_]{2,2}\/[\_]{2,2}\/[\_]{4,4}$/.test(value)) {
        return (
          this.optional(element) ||
          (/^[0-9\-]{2,2}\/[0-9\-]{2,2}\/[0-9\-]{4,4}$/.test(value) && isDateValid(value))
        );
      }
      return true;
    },
    "Please enter a valid date in MM/DD/YYYY format."
  );

  $("#new_submission").validate({
    onfocusout: function (element) {
      var e = $(element);
      if (e.attr("type")) return;
      e.val(function (_, value) {
        return $.trim(value);
      });
      if (e.closest("div.input-group").has("ul.errors").length > 0) {
        e.closest("div.input-group").find("ul.errors").remove();
      }
      e.valid();
    },
    invalidHandler: function (e, valid) {
      $(".error-flash").remove();
      $(".carton").before(
        "<div class='error-flash'><p>" +
          "There were errors saving your submission, please fix the " +
          "fields indicated in red below and resubmit.</p></div>"
      );
    },
    errorPlacement: function (error, element) {
      var inputGroupDiv = element.closest("div.input-group");

      if (inputGroupDiv.has("ul.errors").length < 1) {
        var list = $("<ul class='errors'/>").appendTo(inputGroupDiv);
        if (error.text().includes("mimetype")) {
          list.append("<li>" + "Please select a valid file type." + "</li>");
        } else {
          list.append("<li>" + error.text() + "</li>");
        }

        $(".opaque-spinner-bg").css("display", "none");
      }
    },
    highlight: function (element, error, valid) {
      $(element).closest(".input-parent").addClass("error");
    },
    unhighlight: function (element, error, valid) {
      var inputGroupDiv = $(element).closest("div.input-group");

      $(element).closest(".input-parent").removeClass("error");
      if (inputGroupDiv.has("ul.errors").length > 0) {
        inputGroupDiv.find("ul.errors").remove();
      }
      if ($("ul.errors").length < 1) {
        $(".error-flash").fadeOut();
        $(".file-warning").fadeOut();
      }
    },
  });

  $("input.phone").mask("(999) 999-9999", { autoclear: false });
  $("input.phone-required").mask("(999) 999-9999", { autoclear: false });
  $("input.currency").maskMoney({ prefix: "$", allowZero: true });
  $("input.currency-required").maskMoney({ prefix: "$", allowZero: true });
  $("input.date").mask("99/99/9999", { autoclear: false });
  $("input.date-required").mask("99/99/9999", { autoclear: false });

  $(function () {
    $.each($.validator.methods, function (key, value) {
      $.validator.methods[key] = function () {
        var el = $(arguments[1]);
        if (el.is("[placeholder]") && arguments[0] == el.attr("placeholder"))
          arguments[0] = "";

        return value.apply(this, arguments);
      };
    });
  });
});
